import Vue from 'vue'
import App from './App.vue'
import router from './router'
import wow from 'wowjs'
// import 'animate.css'
import "./assets/css/common.min.css"
import {TabPane, Tabs} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.component(TabPane.name, TabPane);
Vue.component(Tabs.name, Tabs);

Vue.config.productionTip = false
Vue.prototype.$wow = wow

new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>',
  render: h => h(App),
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js